import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { Button } from 'primereact/button';
import CustomDropdown from '../../../custom/customDropdown';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { InputText } from 'primereact/inputtext';
import handlePrintWageRS from '../dnevniceStrane/dnevniceRSStampa';
import handlePrintWageIno from '../dnevniceStrane/dnevniceInoStampa';


const Dnevnice = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const justResetRef = useRef(false);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const role = useSelector(state => state.user_role)
        const trip = useSelector(state => state.trip)
        const user = useSelector(state => state.user)
        const [idWage, setIdWage] = useState(null);
        const [zemljeDB, setZemljeDB] = useState([]);
        const [hasRS, setHasRS] = useState(false)
        const [obracunRS, setObracunRS] = useState(false)
        const [hasIno, setHasIno] = useState(false)
        const [obracunIno, setObracunIno] = useState(false)
        const [vozaciNaTuriDB, setVozaciNaTuriDB] = useState([]);
        const [tripOld, setTripOld] = useState(null);
        const [izabran, setIzabran] = useState(false)
        
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
                const [selectedRowIdWage , setSelectedRowIdWage] = useState(null);
                const isSelected = (row) => String(getIdWage(row)) === String(selectedRowIdWage);
        
                const [globalFilter, setGlobalFilter] = useState(null);
                const [first, setFirst] = useState(0);
                const [tableData, setTableData] = useState(null);
                const [allColumns, setAllColumns] = useState([]);
                const [selectedColumns, setSelectedColumns] = useState([]);
                 const [originalColumnOrder, setOriginalColumnOrder] = useState([]);


        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdWage = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;

        ///DATA

    const [formDataWages, setFormDataWages] = useState({
        vaziOd: null,
        vaziDo: null,
        id_zaposleni: null,
        id_drzava: null,
        napomena: '',
        });

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const handleChange = (e) => {
        const { name, value, checked  } = e.target;

        if (name in formDataWages) {
            if(name === 'vaziDo' && formDataWages.vaziOd != null && (formDataWages.vaziOd >= value)) {
                setFormDataWages(prev => ({ ...prev, vaziDo: null }));
                setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                return
            } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
            }
            if(name === 'id_zaposleni') {
              vratiObracunDnevnica(trip,value)
            }
        setFormDataWages(prev => ({ ...prev, [name]: value }));
        }
    };

    const resetData = ()=> {
        setFormDataWages({
            vaziOd: null,
            vaziDo: null,
            id_zaposleni: null,
            id_drzava: null,
            napomena: '',
        });
        setObracunRS(false);
        setObracunIno(false);
}

const vratiObracunDnevnica = (idTrip, idZaposleni) => {
   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id: idTrip,
                                  id_zaposleni: idZaposleni
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetWagesForDriverForTrip", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                console.log(data)
                                setObracunRS(false);
                                setObracunIno(false);
                                if(data && data.RS)
                                  setObracunRS(data.RS)

                                if(data && data.INO)
                                  setObracunIno(data.INO)
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });

}

   useEffect(()=>{
    if(trip != tripOld){
        resetData()
        setTripOld(trip)
        justResetRef.current = true
    }
    if(trip) {
          if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id: trip
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetTypesAndWagesTrip", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                if(data[0]?.message){
                                      toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje!",
                                        detail: data[0]?.message,
                                        life: 3000,
                                    });
                                    return
                                }

                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                if(parsedData.WarnStope){
                                    toast.current.show({
                                        severity: "warn",
                                        summary: "Nedostaju stope dnevnica!",
                                        detail: `Proverite konfiguraciju dnevnica u Administracija > Dnevnice za zemlje: ${parsedData.WarnStope}`,
                                        life: 12000,
                                    });
                                    setZemljeDB(parsedData.ZemljeDB);
                                    setVozaciNaTuriDB(parsedData.VozaciNaTuriDB);
                                    return;
                                }

                                setZemljeDB(parsedData.ZemljeDB)
                                setVozaciNaTuriDB(parsedData.VozaciNaTuriDB)

                                if(parsedData.VozaciNaTuriDB && parsedData.VozaciNaTuriDB.length > 0 && (justResetRef.current || formDataWages.id_zaposleni == null)){
                                justResetRef.current = false
                                setFormDataWages(prev => ({ ...prev, ['id_zaposleni']: parsedData.VozaciNaTuriDB[0].value }));
                                vratiObracunDnevnica(trip, parsedData.VozaciNaTuriDB[0].value)
                                }
                                if(parsedData.DnevniceNaTuriDB){
                                    setTableData(parsedData.DnevniceNaTuriDB)
                                    setHasRS(parsedData?.DnevniceNaTuriDB.some(item => item["Država"] === "RS"));
                                    setHasIno(parsedData?.DnevniceNaTuriDB.some(item => item["Država"] !== "RS"));

                                    if (parsedData?.DnevniceNaTuriDB && parsedData?.DnevniceNaTuriDB.length > 0) {
                                                    const columns = Object.keys(parsedData?.DnevniceNaTuriDB[0])
                                                        .filter(key => !['ID'].includes(key))
                                                        .map(key => ({
                                                        label: key,
                                                        value: key
                                                        }));
                                                    setAllColumns(columns);
                                                    const originalOrder = Object.keys(parsedData?.DnevniceNaTuriDB[0]);
                                                    setOriginalColumnOrder(originalOrder);
                                                    setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                    } else {
                                                    setAllColumns([])
                                                    setSelectedColumns([])
                                                    setOriginalColumnOrder([])
                                                    }
                                } else {
                                  setTableData([])
                                  setAllColumns([])
                                  setSelectedColumns([])
                                  setOriginalColumnOrder([])
                                  setHasRS(false)
                                  setHasIno(false)
                                }
                               

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
    }
    } else {
             toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste izabrali putni nalog!",
                          life: 3000,
                      });
    }
  
      },[formSubmitted, trip])




    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali dnevnicu da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetWage", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka dnevnice!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataWages({
        vaziOd: apiData[0].vaziOd ? new Date(apiData[0].vaziOd) : null,
        vaziDo: apiData[0].vaziDo ? new Date(apiData[0].vaziDo) : null,
        id_zaposleni: apiData[0].id_zaposleni || null,
        id_drzava: apiData[0].id_drzava || null,
        napomena: apiData[0].napomena || ''
      });
};




const handleDeleteFuncWage = () => {
       
            confirmDialog({
            message: "Želite obrisati dnevnicu?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {

 setFormSubmitted(true)

  if (idWage) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idWage
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/DeleteWage", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešna brisanje dnevnice!",
                life: 3000,
                });
                resetData()
                setFormSubmitted(false)
                setIdWage(null)
                setSelectedRowIdWage(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali dnevnicu za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValueWages = Object.values(formDataWages).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataWages,
                        vaziOd: toUtcIso(formDataWages.vaziOd),
                        vaziDo: toUtcIso(formDataWages.vaziDo)
                        };

                  if(izabran && idWage){
                 if(hasAnyValueWages){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idWage),
                                id_putni_nalog: trip,
                                formDataWages: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/UpdateWage", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima dnevnice.' && data[0].message != 'Uspešna izmena!'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima dnevnice.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka dnevnice!",
                                life: 3000,
                                });
                               
                               }
                                setFormSubmitted(false)
                                
                                setIdWage(null)
                                setSelectedRowIdWage(null)
                                setIzabran(false)
                                resetData() 
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke dnevnice!",
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValueWages){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_putni_nalog: trip,
                                  formDataWages: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/InsertWage", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data) {
                                        if(data.message === 'Nedostaju obavezna polja za unos dnevnice.'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka dnevnice!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke dnevnice za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      setFormSubmitted(false);
    };   
  

  
  
  // Da li izabrani vozač ima šta da se štampa za tu stranu (u zemlji / INO).
  // Domaća/strana klasifikacija dolazi iz backenda (trip.IzracunajDnevnicu: id_drzava = država firme),
  // pa radi ispravno i za HR/SI firme — ne oslanjamo se na hardkodovan "RS" iz oznake države.
  const imaObracunStranu = (o) => !!o && (Number(o.UkupnoDnevnicaCount) > 0 || Number(o.UkupnoZaIsplatuEur) > 0);

  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Dnevnice');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Dnevnice sa ture- ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
         <div className="export-buttons fakture-stavke-header">
          <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              {selectedRowIdWage && <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncWage} data-pr-tooltip="Obriši" />}
          </div>
          <input
              type="search"
              onInput={(e) => setGlobalFilter(e.target.value)}
              placeholder={t('nova.phPretraga')}
              className="p-inputtext p-component"
          />
        </div>
      );
      
     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseWage = (rowData) => {
        const id = getIdWage(rowData);

        setSelectedRowIdWage((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdWage(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdWage(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplateWork = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseWage(rowData)}
              />
            
        </div>
      );
    };

    const handlePrintWage1 = () => {
        if(trip) {
              let requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token,
              },
              body: JSON.stringify({
                id: trip,
                id_zaposleni: formDataWages.id_zaposleni,
                step: 'RS'
              }),
            };
            
            fetch(process.env.REACT_APP_BACKEND_URL + "/trip/printWage", requestOptions)
              .then(handleErrors)
              .then((data) => {

                if(data){
                      if(data[0].message){
                         toast.current.show({
                            severity: "warn",
                            summary: "Upozorenje!",
                            detail: data[0].message,
                            life: 3000,
                          });
                        return
                      }
                }
    
                 const stringifiedJson = data[0]["JsonOutput"];
                const parsedData = JSON.parse(stringifiedJson);

                 if(parsedData){
                   handlePrintWageRS(parsedData)
                 } 
        
        
              })
              .catch((error) => {
                error.json().then((errorMessage) => {
                  toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: errorMessage.message,
                    life: 3000,
                  });
                  console.log(errorMessage);
                });
              });
            } else {
               toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Niste izabrali putni nalog kako bi štampali RS dnevnice!",
                    life: 3000,
                  });
            }
      }

    const handlePrintWage2 = () => {
      
        if(trip) {
              let requestOptions = {
               method: "POST",
               headers: {
                 "Content-Type": "application/json",
                 Authorization: "Bearer " + auth.token,
               },
               body: JSON.stringify({
                  id: trip,
                  id_zaposleni: formDataWages.id_zaposleni,
                  step: 'INO'
               }),
             };
            
             fetch(process.env.REACT_APP_BACKEND_URL + "/trip/printWage", requestOptions)
               .then(handleErrors)
               .then((data) => {

                if(data){
                      if(data[0].message){
                         toast.current.show({
                            severity: "warn",
                            summary: "Upozorenje!",
                            detail: data[0].message,
                            life: 3000,
                          });
                        return
                      }
                }
    
                  const stringifiedJson = data[0]["JsonOutput"];
                  const parsedData = JSON.parse(stringifiedJson);

                 if(parsedData){
                   handlePrintWageIno(parsedData)
                 } 
        
               })
               .catch((error) => {
                 error.json().then((errorMessage) => {
                   toast.current.show({
                     severity: "error",
                     summary: "Error",
                     detail: errorMessage.message,
                     life: 3000,
                   });
                   console.log(errorMessage);
                 });
               });
             } else {
                toast.current.show({
                     severity: "warn",
                     summary: "Upozorenje!",
                     detail: "Niste izabrali putni nalog kako bi štampali RS dnevnice!",
                     life: 3000,
                   });
             }
      }

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        
    
            <div className='col-12 md:col-6'>
                          <div className='blagajnaDashboard dnevniceDashboard'>
                             <Card>
                            <div style={{minWidth:'100%', marginBottom: '1%', paddingBottom:'1%', borderBottom:'1px solid rgb(224, 221, 221)'}}>
                                <CustomDropdown
                                                 id="id_zaposleni" 
                                                 name="id_zaposleni" 
                                                 required
                                                invalid={invalidControl(formDataWages.id_zaposleni)}
                                                 value={formDataWages.id_zaposleni} 
                                                 options={vozaciNaTuriDB || []}
                                                 placeholder={t('ture.phVozaca')}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                                {trip && imaObracunStranu(obracunRS) ? <Button label={t('ture.dnevnicaZemlja')} icon="pi pi-print" severity="secondary" className="mt-3 zaposleniShift" onClick={handlePrintWage1} /> : null}
                                {trip && imaObracunStranu(obracunIno) ? <Button label={t('ture.dnevnicaIno')} icon="pi pi-print" severity="secondary" className="mt-3 zaposleniShift" onClick={handlePrintWage2} /> : null}
                            </div>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%', height:'100%'}}>
                            <div className="gridLicni" style={{marginBottom:'1%', paddingTop:'1%'}}>
                                <div className="col-12 md:col-6">
                                <label htmlFor="vaziOd">{t('ture.vaziOd')}:</label>
                                    <Calendar required 
                                    invalid={invalidControl(formDataWages.vaziOd)} 
                                    id="vaziOd" 
                                    name="vaziOd" 
                                    value={formDataWages.vaziOd} 
                                    onChange={handleChange} showIcon dateFormat="dd.mm.yy" showTime hourFormat="24" mask="99.99.9999 99:99"/>
                                </div>
                                <div className="col-12 md:col-6">
                                <label htmlFor="vaziDo">{t('ture.vaziDo')}:</label>
                                {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                                    <Calendar required 
                                    invalid={invalidControl(formDataWages.vaziDo)} 
                                    id="vaziDo" 
                                    name="vaziDo" 
                                    value={formDataWages.vaziDo} 
                                    onChange={handleChange} showIcon dateFormat="dd.mm.yy" showTime hourFormat="24" mask="99.99.9999 99:99"/>
                                </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_zaposleni">{t('ture.vozac')}:</label>
                                            <CustomDropdown
                                                 id="id_zaposleni" 
                                                 name="id_zaposleni" 
                                                 required
                                                invalid={invalidControl(formDataWages.id_zaposleni)}
                                                 value={formDataWages.id_zaposleni} 
                                                 options={vozaciNaTuriDB || []}
                                                 placeholder={t('ture.phVozaca')}
                                                 optionLabel="label"
                                                 onChange={handleChange} />
                              </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="id_drzava">{t('ture.drzava')}:</label>
                                            <CustomDropdown 
                                                id="id_drzava" 
                                                name="id_drzava" 
                                                required
                                                invalid={invalidControl(formDataWages.id_drzava)}
                                                value={formDataWages.id_drzava} 
                                                options={zemljeDB || []} 
                                                optionLabel="label"
                                                onChange={handleChange}
                                                placeholder={t('nova.phDrzavu')}
                                            />
                              </div>
                              <div className="col-12 md:col-6 maxWidthInput" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="pin">{t('nova.napomena')}:</label>
                                            <InputText 
                                                id="napomena"
                                                name="napomena"
                                                value={formDataWages.napomena}
                                                onChange={handleChange}
                                                />
                              </div>

                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                              <div style={{minWidth:'100%', marginTop: '1%',borderTop:'1px solid rgb(224, 221, 221)', display:'flex', justifyContent:'space-between', height: '40%'}}>
                              {obracunRS && (
                                <div style={{width:'48%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                  <h4 style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}>{t('ture.uZemlji')}</h4>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Dnevnica:</p><strong>{obracunRS.UkupnoDnevnicaEur} {obracunRS.ValutaOznaka}</strong></div>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Troškovi:</p><strong>{obracunRS.UkupnoTroskoviEur} {obracunRS.ValutaOznaka}</strong></div>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Za isplatu:</p><strong>{obracunRS.UkupnoZaIsplatuEur} {obracunRS.ValutaOznaka}</strong></div>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Broj dana:</p><strong>{obracunRS.UkupnoDnevnicaCount}</strong></div>
                                </div>
                              )}
                              {obracunIno && (
                                <div style={{width:'48%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                  <h4 style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}>{t('ture.uInostranstvu')}</h4>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Dnevnica:</p><strong>{obracunIno.UkupnoDnevnicaEur} {obracunIno.ValutaOznaka}</strong></div>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Troškovi:</p><strong>{obracunIno.UkupnoTroskoviEur} {obracunIno.ValutaOznaka}</strong></div>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Za isplatu:</p><strong>{obracunIno.UkupnoZaIsplatuEur} {obracunIno.ValutaOznaka}</strong></div>
                                  <div style={{paddingLeft: '20%',display:'flex', justifyContent:'left', minWidth:'100%'}}><p style={{marginRight:'1%', marginBottom: 'auto', minWidth:'30%'}}>Broj dana:</p><strong>{obracunIno.UkupnoDnevnicaCount}</strong></div>
                                </div>
                              )}
                            </div>
                            </form>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                     <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
                                       <div style={{ width: "20%" }}>
                                         {allColumns.length > 0 && (
                                           <MultiSelect
                                             value={selectedColumns}
                                             options={allColumns}
                                             onChange={(e) => {
                                 const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
                                 setSelectedColumns(sorted);
                               }}
                                             optionLabel="label"
                                             display="chip"
                                             placeholder={t('nova.odaberiteKolone')}
                                             style={{ width: '100%' }}
                                             showSelectAll={true}
                                             filter
                                             filterPlaceholder="Pretraži kolone"
                                             maxSelectedLabels={3}
                                             selectedItemsLabel="{0} kolona odabrano"
                                           />
                                         )}
                                       </div>
                                     </div>
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplateWork(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                

       </div>
)
}
export default Dnevnice;